export default function getTrueCategoryFromAlgoliaCategoryList(categoryString: string): string {
  const splitString = categoryString.split(" > ");
  return splitString[splitString.length - 1].trim();
}
